import React from "react";

import imaLogo from './images/ima_logo.png';
import rssLogo from './images/RSS_logo.jpg';
import lmsLogo from './images/LMS_logo.jpg';
import uclanLogo from './images/uclan_logo.png';

export default function App() {
  const now = new Date();
  const gmtTimestamp = now.toLocaleString("en-GB", {
    timeZone: "GMT",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "white",
        color: "#1f2937",
        padding: "2rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      <header style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>

        <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem" }}>
          Fostering Engagement and Learning in Mathematics in the Digital Age
        </h1>

        <p style={{ fontSize: "1.1rem", fontWeight: "600", color: "#b91c1c" }}>
          Thursday 12th June 2025 | 10:00 AM – 5:00 PM
        </p>

        <p style={{ fontSize: "1.1rem", fontWeight: "600", color: "#b91c1c" }}>
          University of Central Lancashire
        </p>

        <div style={{ marginTop: "0.75rem" }}>
          <img
            src={uclanLogo}
            alt="UCLan Logo"
            style={{
              maxHeight: "120px",
              width: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />
        </div>
      </header>

      <main style={{ maxWidth: "1350px", margin: "2rem auto" }}>







        <section>
          <h2>About the Workshop</h2>

          <p>
            The integration of digital technologies into higher education, especially after the COVID-19 pandemic, has
            transformed every aspect of teaching and learning mathematics. This workshop explores challenges and
            opportunities brought by this transformation, including strategies to enhance student engagement using
            platforms such as VLE, and ways to deliver meaningful online content, feedback, and formative assessment.
          </p>

          <p>
            We'll explore evidence-based strategies, tools like gamification, and adaptive learning platforms to
            personalise experiences and improve outcomes. The workshop also investigates the role of feedback and
            formative assessment in digital education, seeking innovative methods beyond automated grading.
          </p>

          <p>
            <strong>
              This workshop is a part of IMA-LMS-RSS Higher Education Teaching and Learning Workshop Series 2024/25.
              More information on the Higher Education Teaching and Learning Series can be found{' '}
              <a
                href="https://ima.org.uk/26488/higher-education-teaching-and-learning-workshop-series-2024-25-successful-proposals/?"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2563eb' }}
              >
                here
              </a>.
            </strong>
          </p>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '2rem',
              marginTop: '1rem',
            }}
          >
            <img src={imaLogo} alt="IMA Logo" style={{ maxHeight: '60px', width: 'auto' }} />
            <img src={rssLogo} alt="RSS Logo" style={{ maxHeight: '60px', width: 'auto' }} />
            <img src={lmsLogo} alt="LMS Logo" style={{ maxHeight: '60px', width: 'auto' }} />
          </div>
        </section>






        <section>
          <h2>Registration</h2>
          <p>
            Registration is free. Please register using the following link:
            <br />
            <a href="https://forms.office.com/e/VbvUsK4G7p" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>
              Register here
            </a>
          </p>
        </section>






        <section>
          <h2>Workshop Format</h2>
          <p>
            The workshop will run from 10:00 AM to 5:00 PM on Thursday 12th June 2025. It will include two main
            sessions (morning and afternoon), each consisting of keynote talks, contributed talks, and open
            discussions. Lunch and refreshments will be provided.
          </p>
        </section>






        <section>
          <h2>Themes</h2>
          <ul>
            <li>Morning: Increasing student engagement in the Digital Age</li>
            <li>Afternoon: Meaningful feedback and formative assessment</li>
          </ul>
        </section>





        <section>
  <h2>Invited Speakers</h2>
  <div
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      gap: '2rem',
    }}
  >
    {/* Speaker 1 */}
    <div
      id="craig-alexander"
      style={{
        flex: '1 1 calc(48%)',
        minWidth: '300px',
        border: '1px solid #ddd',
        padding: '1rem',
        borderRadius: '8px',
        boxSizing: 'border-box',
      }}
    >
      <h3>
        <a
          href="https://www.gla.ac.uk/schools/mathematicsstatistics/staff/craigalexander/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1f2937', textDecoration: 'none' }}
        >
          Dr Craig Alexander
        </a>
      </h3>
      <p>Lecturer (Statistics)<br />University of Glasgow</p>
      <p>
        Dr Alexander focuses on statistics and data analytics education, especially in the use of learning technology,
        active learning, and programming instruction.
      </p>
      <p><strong>Title of the talk:</strong> Exploring Online Learning Strategies & Technological Advancements in Mathematical Sciences Education</p>
      <p><strong>Abstract:</strong> In the ever-changing landscape of higher education, keeping students engaged requires innovative approaches that successfully link good pedagogical and technology. This talk explores several strategies from experiences in teaching online distance learning and using technology enhanced learning strategies to improve student engagement. Drawing from experiences in an MSc in Data Analytics program and in a Level 1 Statistics course, I will discuss how structured asynchronous learning, digitally enhanced content creation, and engaging the student community can help foster deeper engagement. Additionally, I will examine how gamification techniques can be effectively integrated into a flipped classroom model to incentivise progress and reinforce key concepts.</p>
    </div>

    {/* Speaker 2 */}
    <div
      id="philip-walker"
      style={{
        flex: '1 1 calc(48%)',
        minWidth: '300px',
        border: '1px solid #ddd',
        padding: '1rem',
        borderRadius: '8px',
        boxSizing: 'border-box',
      }}
    >
      <h3>
        <a
          href="https://eps.leeds.ac.uk/maths/staff/4091/dr-philip-walker"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1f2937', textDecoration: 'none' }}
        >
          Dr Philip Walker
        </a>
      </h3>
      <p>Associate Professor (Teaching and Scholarship)<br />University of Leeds</p>
      <p>
        Dr Walker explores assessment strategies in mathematics education, with a focus on automatic assessment,
        feedback methods, and student learning approaches.
      </p>
      <p><strong>Title of the talk:</strong> Deploying digital tools to enhance an assessment strategy</p>
      <p><strong>Abstract:</strong> In this talk, I will discuss the use of digital tools to deliver a more scalable assessment strategy that treats students holistically. Beginning with a discussion of some key themes in thinking around assessment, I will use a case study from my own practice to illustrate how digital tools enable the development, in both the initial and ongoing senses, of an assessment strategy that is appropriate to both content and cohort. The ideas and techniques presented rely, for full effect, on digital assessment tools but nevertheless apply broadly across all modes of teaching.</p>
    </div>

    {/* Speaker 3 */}
    <div
      id="richard-gratwick"
      style={{
        flex: '1 1 calc(48%)',
        minWidth: '300px',
        border: '1px solid #ddd',
        padding: '1rem',
        borderRadius: '8px',
        boxSizing: 'border-box',
      }}
    >
      <h3>
        <a
          href="https://maths.ed.ac.uk/people/a-z?person=518"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1f2937', textDecoration: 'none' }}
        >
          Dr Richard Gratwick
        </a>
      </h3>
      <p>Reader<br />University of Edinburgh</p>
      <p>
        Dr Gratwick combines his passion for in-person teaching with the flexible benefits of online delivery,
        drawing on experience from both the classroom and research in calculus of variations.
      </p>
      <p><strong>Title of the talk:</strong> Technological Innovations in Course Design and Delivery at the University of Edinburgh</p>
      <p><strong>Abstract:</strong> I will describe some ways in which we use technology in our courses in the School of Mathematics at the University of Edinburgh to promote student interaction and engagement both within and beyond the classroom.  I will talk about a recently redesigned complex analysis course, the materials for which are delivered through a set of interactive STACK workbooks, which is now well embedded in the School, and give an overview of other practices and technologies, e.g. flipped classrooms, in-class polling, and online discussion forums, being used in the School.</p>
    </div>

    {/* Speaker 4 */}
    <div
      id="lorena-zapata"
      style={{
        flex: '1 1 calc(48%)',
        minWidth: '300px',
        border: '1px solid #ddd',
        padding: '1rem',
        borderRadius: '8px',
        boxSizing: 'border-box',
      }}
    >
      <h3>
        <a
          href=""
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1f2937', textDecoration: 'none' }}
        >
          Lorena Zapata
        </a>
      </h3>
      <p>Anthology</p>
      <p>
        Lorena Zapata will present recent developments in Blackboard Ultra regarding support for mathematical notation using MathJax.
      </p>
      <p><strong>Title of the talk:</strong> Including Mathematics in Blackboard Ultra</p>
      <p><strong>Abstract:</strong> This talk will provide an update on the inclusion of MathJax support in Blackboard Ultra. This will include information about when MathJax support will become available and demonstration of the update.</p>
    </div>
  </div>
</section>










        <section>
          <h2>Contributed Talks</h2>
          <p>
            Contributed talks are welcome from participants. Each talk is expected to be between 15–30 minutes. Exact
            details will be conveyed to selected participants in due time. Anyone interested in giving a contributed
            talk should mention it in the registration form along with a short abstract.
          </p>
        </section>







        <section>
  <h2>Venue</h2>
  <p>
    Foster Lecture Theatre 2, Foster Building, University of Central Lancashire, Preston
  </p>

  <p style={{ marginTop: '1rem' }}>
    The <strong>Foster Building</strong> is approximately a 12–15 minute walk from Preston Railway Station.
    On exiting the station, turn right onto Fishergate. Walk up Fishergate until you reach Corporation Street. 
    Turn left onto Corporation Street and continue walking. The Foster Building will be on your left. Follow the directional signs there to locate the lecture theatre.
  </p>

  <div style={{ marginTop: "1rem" }}>
    <iframe
      title="Foster Building Map"
      src="https://www.google.com/maps?q=Foster+Building,+University+of+Central+Lancashire,+Preston&output=embed"
      width="100%"
      height="300"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
</section>







        <section>
          <h2>How to Reach Preston</h2>
          <p><strong>By Train:</strong> Preston is a major stop on the West Coast Main Line.</p>
          <ul>
            <li><strong>From London:</strong> Direct trains from London Euston via Avanti West Coast (~2h 8min)</li>
            <li><strong>From Manchester Airport:</strong> Direct services by TransPennine Express (~1h)</li>
          </ul>
          <p><strong>By Bus/Coach:</strong> Coaches from Manchester Airport to Preston take just over an hour. Preston Bus Station has national and regional connections.</p>

{/*
          <p><strong>By Car:</strong></p>
          <ul>
            <li><strong>From the South:</strong> Exit M6 at Junction 29 and follow signs for Preston</li>
            <li><strong>From the North:</strong> Exit M6 at Junction 32 onto M55, then Exit 1 to Preston</li>
          </ul>
*/}

          <p><strong>Local Transport:</strong> Local buses and taxis are readily available within the city.</p>
        </section>



<section>
  <h2>WiFi at Campus</h2>
  <p>
    Participants who already use <strong>eduroam</strong> can connect to it on campus using their existing institutional login credentials. Eduroam is available throughout the UCLan campus and provides secure, high-speed wireless internet access.
  </p>
  <p>
    In addition, we offer free Wi-Fi across the campus. To log on, simply select <strong>‘UCLan-Open’</strong> from the available networks and sign in using your email address.
  </p>
</section>




{/*
        <section>
          <h2>Hybrid Delivery of the Workshop</h2>
          <p>
            To support participants who may have teaching or other institutional commitments during this period,
            we are offering a hybrid attendance option. If you prefer to join the workshop remotely, you can indicate this
            on the registration form — there is a specific question for it. However, please note that the workshop
            is primarily designed as an in-person event, and the full benefit of participation is typically gained on-site.
            Some parts of the programme, such as group discussions, may not be fully available online. We therefore
            encourage in-person attendance wherever feasible.
          </p>
        </section>
*/}







        <section>
          <h2>Schedule</h2>
<table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem" }}>
            <tbody>
              {[
                ["09.30 - 10:00", "Registration and Refreshments"],
                ["10.00 - 10:10", "Opening"],
                ["Morning session", "“Increasing student engagement in the Digital Age”"],
                ["10.10 - 11.00", <a href="#craig-alexander">Invited Talk: Dr Craig Alexander</a>],
                ["11.00 - 11.25", <a href="#box-tribello" style={{ color: '#2563eb' }}>Contributed Talk: Gareth Tribello</a>],
		["11.25 - 11.45", "Coffee Break"],
		["11.45 - 12.35", <a href="#richard-gratwick">Invited Talk: Dr Richard Gratwick</a>],
                ["12.35 - 13.00",  <a href="#box-bewsher" style={{ color: '#2563eb' }}>Contributed Talk: Danielle Bewsher</a>],
                ["13.00 - 14.00", "Lunch"],
                ["Afternoon session", "“Meaningful feedback and formative assessment”"],
                ["14.00 - 14.50", <a href="#philip-walker">Invited Talk: Dr Philip Walker</a>],
                ["14.50 - 15.15", <a href="#box-walton" style={{ color: '#2563eb' }}>Contributed Talk: Timothy Walton</a>],
                ["15.15 - 16.00", "Refreshment and Discussion"],
                ["16.00 - 16.30", <a href="#lorena-zapata">Special Invited Session: Lorena Zapata</a>],
                ["16.30 - 17.00", "Networking and Closing Remarks"]
              ].map((row, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff" }}>
                  <td style={{ padding: "0.5rem", border: "1px solid #ccc", width: "30%" }}>{row[0]}</td>
                  <td style={{ padding: "0.5rem", border: "1px solid #ccc" }}>{row[1]}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ fontStyle: "italic", fontSize: "0.9rem", marginTop: "0.5rem" }}>* Schedule is subject to change</p>
        </section>





<section>
  <h2>Contributed Talks</h2>
  <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '1.5rem' }}>
    
    {/* Gareth Tribello */}
    <div id="box-tribello" style={{ flex: '1 1 calc(31%)', minWidth: '260px', border: '1px solid #ddd', padding: '1rem', borderRadius: '8px', boxSizing: 'border-box' }}>
      <h3>Gareth Tribello</h3>
      <p>Queen's University Belfast</p>
      <p><strong>Title of the talk:</strong> Community Engaged Research for mathematics education</p>
      <p><strong>Abstract:</strong> Introducing digital environments can improve student engagement with mathematics. However, I believe the better strategy for getting students to engage is to get them to use what they have learned about mathematics to complete real-world projects that have some meaning and importance to them. Community-engaged research and learning (CERL) is a constructive approach to education that combines community engagement, learning, teaching and research. In CERL, students and lecturers work on projects suggested by community partners. These projects offer students opportunities for authentic learning by allowing them to apply their discipline-specific knowledge and skills and transferrable professional skills outside a traditional academic setting. In my talk, I will discuss how an initial interest in using digital technologies to support my teaching led me to using this type of teaching. I will endeavour to show how you can introduce meaningful projects into mathematics modules without introducing a great deal of additional work for yourself and how richly rewarding engaging this type of teaching can be.</p>
    </div>

    {/* Danielle Bewsher */}
    <div id="box-bewsher" style={{ flex: '1 1 calc(31%)', minWidth: '260px', border: '1px solid #ddd', padding: '1rem', borderRadius: '8px', boxSizing: 'border-box' }}>
      <h3>Danielle Bewsher</h3>
      <p>University of Central Lancashire</p>
      <p><strong>Title of the talk:</strong> Technology Solutions for the Capture of Whiteboards during Teaching Events</p>
      <p><strong>Abstract:</strong> Mathematics and mathematically inclined science disciplines make extensive use of whiteboards during teaching events. It is common to use multiple whiteboards and produce a number of whiteboards worth of material during an hour of contact time. Capturing this in a useful way for review by students remotely or at a future date has presented significant challenges.
In this presentation, I will describe a bespoke dual camera solution that performs a variety of image enhancements to best optimise the capture of whiteboard material that we have been trialling in the School of Engineering & Computing. I will discuss staff impressions and student feedback on the new system.</p>
    </div>

    {/* Timothy Walton */}
    <div id="box-walton" style={{ flex: '1 1 calc(31%)', minWidth: '260px', border: '1px solid #ddd', padding: '1rem', borderRadius: '8px', boxSizing: 'border-box' }}>
      <h3>Timothy Walton</h3>
      <p>University of Central Lancashire</p>
      <p><strong>Title of the talk:</strong> Computer-Aided Assessment in Foundation Mathematics at UCLan</p>
      <p><strong>Abstract:</strong> This talk is a reflection on the previous 5 years of teaching Foundation Mathematics to undergraduate Computing and Engineering students with a specific focus on the use of Mobius, a computer-aided assessment system that has been in use for the previous 4 years. The talk will include discussions on developing assessments, providing feedback, measures to maintain academic integrity and student response to Mobius.</p>
    </div>

  </div>
</section>









        <section>
          <h2>Organising Committee</h2>
          <ul>
            <li>Dr Davide Penazzi, Senior Lecturer in Mathematics, School of Engineering and Computing, University of Central Lancashire</li>
            <li>Dr Daniel Brown, Reader in Solar Physics, School of Engineering and Computing, University of Central Lancashire</li>
            <li>Dr Timothy Walton, Senior Lecturer and Course Leader in Mathematics, School of Engineering and Computing, University of Central Lancashire</li>
            <li>Dr Subhrajyoti Saha, Lecturer in Mathematics, School of Engineering and Computing, University of Central Lancashire</li>
          </ul>
        </section>








        <section>
          <h2>Contact</h2>
          <p>If you have any queries, please contact Dr Subhrajyoti Saha at <a href="mailto:ssaha2@uclan.ac.uk">ssaha2@uclan.ac.uk</a>.</p>
        </section>





	<section>
          <h2>Other Workshops in the Higher Education Teaching and Learning Series 2025</h2>
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "1rem" }}>
            <thead>
              <tr style={{ backgroundColor: '#f3f4f6' }}>
                <th style={{ border: '1px solid #ccc', padding: '0.5rem', textAlign: 'left' }}>Date</th>
                <th style={{ border: '1px solid #ccc', padding: '0.5rem', textAlign: 'left' }}>Event Title</th>
                <th style={{ border: '1px solid #ccc', padding: '0.5rem', textAlign: 'left' }}>Institution</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["4 JULY", <a href="https://www.imperial.ac.uk/events/193747/ima-lms-teaching-workshop/" target="_blank" rel="noopener noreferrer">Rethinking feedback and assessment: what does this mean in traditionally exam-based mathematics?</a>, "Imperial College London"],
                ["10 JULY", <a href="https://forms.office.com/pages/responsepage.aspx?id=VdQuDq-WAEG-06jl_ZgWhaqlj7MNeehFg85qbME3VxhUOEVQMlBDQVpUOFIxSkg5V0xNSkJBVEdIQy4u&route=shorturl" target="_blank" rel="noopener noreferrer">Enhancing Student Community and Learning: Adapting Strategies for Changing Patterns of Student Engagement</a>, "The Open University"],
                ["18 JULY", <a href="https://oevkaya.github.io/HE-Workshop-Series/?" target="_blank" rel="noopener noreferrer">Rethinking Teaching and Learning in The Mathematical Sciences in Times of Generative AI</a>, "University of Edinburgh"],
                ["29 JULY", <a href="https://pcwww.liv.ac.uk/~itho17/workshop2025/?" target="_blank" rel="noopener noreferrer">Automatic grading in mathematics and statistics: beyond the basics</a>, "University of Liverpool"]
              ].map((row, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9" }}>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem', fontWeight: 'bold' }}>{row[0]}</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem', fontStyle: 'italic' }}>{row[1]}</td>
                  <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>{row[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ fontStyle: "italic", fontSize: "0.9rem", marginTop: "0.5rem" }}>* For any queries related to the other workshops in the series, please contact the respective organisers or the IMA Education Team.</p>
        </section>








        <p style={{ textAlign: 'center', fontSize: '0.8rem', color: '#888', marginTop: '2rem' }}>
          Last refreshed: {gmtTimestamp} GMT
        </p>
      </main>
    </div>
  );
}